import { Type } from 'class-transformer';
import type dayjs from 'dayjs';
import { Call } from './call';
import { Email } from './email';
import { Model } from './model';
import { Partner } from './partner';
import { Invoice } from './invoice';
import { TransformStringToDayJS } from './utils';

export enum Direction {
  INBOUND = 'inbound',
  OUTBOUND = 'outbound',
}

export enum ActivityType {
  CALL = 'call',
  EMAIL = 'email',
}

interface ActivityConstructorParams {
  call?: Call | null;
  email?: Email | null;
}

export class Activity extends Model {
  id: string;

  activity_type: ActivityType;

  @Type(() => Call)
  call?: Call | null;

  direction: Direction;

  @Type(() => Email)
  email?: Email | null;

  @Type(() => Partner)
  partner?: Partner | null;

  partner_id: string;

  from: string | null;

  to: string;

  @TransformStringToDayJS()
  timestamp: dayjs.Dayjs;

  @Type(() => Invoice)
  invoices: Invoice[];

  constructor(params?: ActivityConstructorParams) {
    super();
    if (params?.call) {
      this.setFromCall(params.call);
    }

    if (params?.email) {
      this.setFromEmail(params.email);
    }
  }

  private setFromCall(call: Call): void {
    this.id = call.id;
    this.activity_type = ActivityType.CALL;
    this.call = call;
    this.direction = Direction.OUTBOUND;
    this.created_at = call.created_at;
    this.timestamp = call.start_time || this.created_at;
    this.from = call.from_number;
    this.to = call.to_number;
    this.partner = call.partner;
    this.invoices = call.invoices;
  }

  private setFromEmail(email: Email): void {
    this.id = email.id;
    this.activity_type = ActivityType.EMAIL;
    this.email = email;
    this.direction = email.direction;
    this.created_at = email.created_at;
    this.timestamp = email.sent_at || this.created_at;
    this.from = email.from_email;
    this.to = email.to[0];
    this.partner = email.thread?.partner;
    this.invoices = email.thread?.invoices ?? [];
  }
}
